import { render, staticRenderFns } from "./ManualVideoAnalysisList.vue?vue&type=template&id=c136278a&scoped=true"
import script from "./ManualVideoAnalysisList.vue?vue&type=script&lang=js"
export * from "./ManualVideoAnalysisList.vue?vue&type=script&lang=js"
import style0 from "./ManualVideoAnalysisList.vue?vue&type=style&index=0&id=c136278a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c136278a",
  null
  
)

export default component.exports